module.exports = __webpack_public_path__ + "img/bg_m2.00e94dc7.png";